const removeDuplicatesFromArray = (str) => {
  return [...new Set(str.split(","))].join(",");
};

export default removeDuplicatesFromArray;
